//import * as auth from './types';

const state /*: auth.State*/ = {
  errors: null,
  user: {},
  isAuthenticated: false,
  authReq: null,
};

export default state;
